import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClipboard, faWater } from '@fortawesome/free-solid-svg-icons'
import InitialDataForm from './InitialDataForm';
import MovieForm from './MovieForm3';
import { COLORS, STRINGS } from './utils/Constants';

let genres = [], countries = [], legalCountries = [], languages = [], timezones = [];

export default class  AddMovie extends React.Component {
    
  state = {
    movieName: '', language: 'Language', timezone: 'Time Zone', uploadID: false, addMovieObj: ''
  };
  componentDidMount() {
    let sessionValue = localStorage.getItem('localStorageSession') || '';
    console.log('sessionValue='+sessionValue);
    if(sessionValue) {
      this.setState({ sessionValue: sessionValue });
    }
  }
  componentDidUpdate() {
    let addMovieObj = this.state.addMovieObj;
    let newMovieObj = this.props.addMovieObj;
    if(!addMovieObj&&newMovieObj) {
      this.setState({ addMovieObj: newMovieObj, uploadID: newMovieObj.id });
    }
  }
  setUploadId = (id) => {
    console.log('upload id set='+id);
    this.setState({ uploadID: id });
  }
  updateMovieObj = (movieObj) => {
    console.log('old movie obj='+JSON.stringify(this.state.addMovieObj)+' new movie obj='+JSON.stringify(movieObj));
    this.setState({ addMovieObj: movieObj.movieInfo });
  }
  render() {
    let data = this.props.generalInfoData;
    let detailsEnabled = this.state.uploadID;
    let legalCountriesArr = this.props.countriesData;
    console.log('uploadId='+detailsEnabled+'add movie props='+this.state.addMovieObj);
    if(legalCountriesArr&&data.genres) {
      legalCountries = legalCountriesArr;
      genres = data.genres;
      countries = data.countries;
      languages = data.languages;
      timezones = data.timezones;
    }
    return (
        <div>
            <div style={{ display: "flex", justifyContent:'center', alignItems: "center", width: '100%' }}>
                <FontAwesomeIcon color={COLORS.yellow} icon={faClipboard} style={{ fontSize: 24, margin: '12px' }} />
                <h2 style={{ fontSize: 20, fontFamily: 'OpenSans-Bold', alignSelf:'center', textAlign:'center', color: COLORS.yellow, marginBottom: 0 }}>
                  Start Movie Listing
                </h2>
                <FontAwesomeIcon color={COLORS.yellow} icon={faClipboard} style={{ fontSize: 24, margin: '12px' }} />                  
            </div>
            <div style={{ display: 'flex', justifyContent:'center', paddingTop: 20 }}>
                <p className="Agree" style={{ whiteSpace: 'pre', fontSize: 13, fontFamily: 'OpenSans-SemiBold', color: COLORS.yellow, lineHeight: 1.2 }}>
                  {STRINGS.listingStr}
                </p>
            </div>
            <InitialDataForm addMovieObj={this.state.addMovieObj} legalCountries={legalCountries} setUploadId={this.setUploadId} 
              detailsEnabled={!detailsEnabled} listingFees={data.listingFees} sendToManage={(uploadedMovies) => { this.props.sendToManage(uploadedMovies) }} />
            
            <div style={{ display: 'flex', width: '100%', justifyContent:'center' }}>
              <FontAwesomeIcon color={COLORS.blue3a4a5a} icon={faWater} style={{ fontSize: 36, margin: 48 }} />
            </div>

            <div style={{ display: 'flex', justifyContent:'center' }}>
              <p className="Agree" style={{ whiteSpace: 'pre', fontSize: 13, fontFamily:'OpenSans-SemiBold', color: COLORS.yellow, lineHeight: 1.2 }}> 
                {STRINGS.paymentStr} 
              </p>
            </div>
            
            <MovieForm addMovieObj={this.props.movieObj} genres={genres} countries={countries} languages={languages} 
              timezones={timezones} disableForm={true} updateMovieObj={this.updateMovieObj} />

        </div>
  );
  }
}
